const firebaseConfig = {
  apiKey: 'AIzaSyArECuRRZxrrQSua-8ZFhKdLSXpVP0r_Uc',
  authDomain: 'the-final-score-7860d.firebaseapp.com',
  databaseURL: 'https://the-final-score-7860d.firebaseio.com',
  projectId: 'the-final-score-7860d',
  storageBucket: 'the-final-score-7860d.appspot.com',
  messagingSenderId: '14785667558',
  appId: '1:14785667558:web:fb1a2e55f07bfcc81bb627',
  measurementId: 'G-7EK7K1PLKW',
};

export default firebaseConfig;
